import { FC } from 'react';

import { useAnalytics } from '@hooks/useAnalytics';

import { useRouter } from '@router/index';

import IconButton from '@components/buttons/IconButton';
import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';
import { AsyncImage } from '@components/layout/AsyncImg';

export const TopKingMaterialSection: FC<{ context: string }> = ({ context }) => {
  const { track } = useAnalytics();
  const { navigate } = useRouter();
  const handleNavigateToTopKingMaterial = () => {
    track('Top King Material Section Clicked', {
      context,
    });
    navigate(`/noauth/top-king-material`);
  };

  return (
    <div
      className="d-flex gap-3 p-2 align-items-center mb-3"
      style={{ background: 'rgba(255,255,255,.1)', borderRadius: 8 }}
      onClick={handleNavigateToTopKingMaterial}
    >
      <div>
        <AsyncImage
          src={`https://gaggl.app/api/public/assets/images/badges/top-king-material.png`}
          style={{
            height: 64,
            width: 64,
            display: 'block',
          }}
        />
      </div>
      <div>
        <strong className="fs-6">Nominate local kings of drag</strong>
        <br />
        <span>Nominate your favorite local kings for a special feature!</span>
      </div>
      <div>
        <IconButton color="neutral" variant="flat">
          <FontAwesomeIcon name="chevron-right" />
        </IconButton>
      </div>
    </div>
  );
};
